<template>
    <div class="d-flex justify-space-between">
        <span>
            {{ label }}
        </span>

        <v-switch
            v-model="trackerSwitch"
            :ripple="false"
            @click.prevent="updateTrackerStatus"
        />
    </div>
</template>

<script>
    export default {
        name: 'TrackerSwitch',
        props: {
            label: {
                type: String,
                required: true
            },
            provider: {
                type: String,
                required: true
            },
            status: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                tracker: null
            }
        },
        computed: {
            trackerSwitch: {
                get() {
                    return this.tracker;
                },
                set(status) {
                    this.tracker = status;
                }
            }
        },
        methods: {
            updateTrackerStatus() {
                this.$emit('set-tracker-userchoice', this.$props.provider, this.trackerSwitch);
            }
        },
        watch: {
            status() {
                this.trackerSwitch = this.$props.status;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/components/TrackerSwitch.vue